import RouterConstants from "../../../constants/RouterConstants";
import { isLegacyTgDemoRoute, isLegacyTgRoute } from "./tg-utils";

export const isNewTgEvaluationRoute = (pathname?: string): boolean => {
	const p = pathname ?? window.location.pathname;
	return p.includes(`/${RouterConstants.NEW_TG.MODELS.EVALUATION.path}`) && !isLegacyTgRoute(p);
};

export const isNewTgDemoRoute = (pathname?: string): boolean => {
	const p = pathname ?? window.location.pathname;
	const isDemo = p.includes(RouterConstants.NEW_TG.DEMO.IMAGE_GENERATION.fullPath);
	const isPlayground = p.includes(RouterConstants.APPS.TG.IMAGE.fullPath);
	return (isPlayground || isDemo) && !isLegacyTgDemoRoute(p);
};

export const isNewTgPlaygroundRoute = (pathname?: string): boolean => {
	return isNewTgEvaluationRoute(pathname) || isNewTgDemoRoute(pathname);
};

export const shouldHidePromptPrefix = (pathname?: string): boolean => isNewTgPlaygroundRoute(pathname);
export const shouldShowUserPromptInGallery = (pathname?: string): boolean => isNewTgPlaygroundRoute(pathname);
export const shouldRestrictToFiboModels = (pathname?: string): boolean => isNewTgPlaygroundRoute(pathname);
export const shouldHideFastToggle = (pathname?: string): boolean => isNewTgPlaygroundRoute(pathname);
export const shouldHideControlNets = (pathname?: string): boolean => isNewTgEvaluationRoute(pathname);
